import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo Api回傳格式
 */
export interface MOauthGenerateResp extends GeneralResp {
    url: string;
}

/**
 * @todo Moauth 產生 url
 */
const MOauthGenerate = (branch: string): Promise<MOauthGenerateResp> => {
    const url = RouteUrlList.API_MOauthGenerate.path;
    const data = {
        branch: branch
    };
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<MOauthGenerateResp>) => {
        return res.data;
    });
};

export default MOauthGenerate;
